/**
 * The pump drawing family — the ids `PumpAnimation.vue` draws.
 *
 * The hub declares `settings.pump_type` on its `pump` class; a device saved
 * before that keeps the choice in its icon/name, which `pumpKindOf` still reads.
 */
import { pumpKindOf } from '../../devices/deviceWidgetTypes';
import { variantFromSetting, variantValues, type VariantFamily } from './types';

export const PUMP_VARIANTS: VariantFamily = {
  drawing: 'pump',
  settingKey: 'pump_type',
  title: ['Pump type', 'Vrsta črpalke'],
  description: [
    'The vessel this pump is. The tile draws it; nothing else changes.',
    'Vrsta te črpalke. Ploščica jo nariše; drugo se ne spremeni.',
  ],
  options: [
    { value: 'auto', icon: 'settings_suggest', label: ['Automatic', 'Samodejno'] },
    { value: 'circulator', icon: 'heat_pump', label: ['Circulator', 'Obtokna črpalka'] },
    { value: 'surface', icon: 'plumbing', label: ['Inline / surface', 'Površinska črpalka'] },
    { value: 'submersible', icon: 'water_full', label: ['Submersible', 'Potopna črpalka'] },
    { value: 'sump', icon: 'flood', label: ['Sump / drainage', 'Kalna črpalka'] },
    { value: 'pool', icon: 'pool', label: ['Pool filter', 'Bazenska črpalka'] },
    { value: 'well', icon: 'water', label: ['Well / borehole', 'Globinska črpalka'] },
    { value: 'sewage', icon: 'wc', label: ['Sewage / grinder', 'Črpalka za odplake'] },
    { value: 'booster', icon: 'faucet', label: ['Pressure booster', 'Tlačna črpalka'] },
  ],
  defaultValue: 'auto',
  resolve: (device) => variantFromSetting(device.settings, 'pump_type', variantValues(PUMP_VARIANTS)) ?? pumpKindOf(device),
};
